import { cn } from "../lib/utils";
import { logoIcon, logoWordmarkDark, logoWordmarkLight } from "../assets";

interface LogoProps {
  className?: string;
  size?: number;
  showText?: boolean;
  variant?: "light" | "dark";
}

export function Logo({ className, size = 60, showText = true, variant = "light" }: LogoProps) {
  const wordmark = variant === "light" ? logoWordmarkDark : logoWordmarkLight;
  const wordmarkHeight = size > 40 ? size : size * 0.7;

  return (
    <div className={cn("flex items-center gap-1 select-none", className)}>
      <img
        src={logoIcon}
        alt="Pozeman icon"
        style={{ width: size, height: size }}
        className="shrink-0 object-contain px-1"
      />

      {showText && (
        <img
          src={wordmark}
          alt="Pozeman"
          style={{ height: wordmarkHeight }}
          className="object-contain mt-2"
        />
      )}
    </div>
  );
}